var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    [
      _c(
        "el-col",
        { staticClass: "video-outer-wrapper", attrs: { span: 24 } },
        [
          _c("div", { staticClass: "video-wrapper" }, [
            _c(
              "video",
              {
                staticClass: "video-style",
                attrs: { autoplay: true, loop: true },
                domProps: { muted: true }
              },
              [
                _c("source", {
                  attrs: { src: _vm.videoUrl, type: "video/mp4" }
                })
              ]
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42d8b7df", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42d8b7df","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/videoPlayWidget.vue
// module id = null
// module chunks = 